// Generates a random number to be used as the key for a .map()
const generateRandomKey = () => {
    return Math.floor(Math.random() * 1000000);
}

export default generateRandomKey;